import { Component, OnInit } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { ReportBuilderService } from '../../services/report-builder.service';
import { ReportEntitySchema } from '../../models/report-builder-schema.model';

/**
 * Reachable from anywhere via the top-level sidebar entry, not nested inside Warehousing or
 * Reporting - this queries across the whole system, not one module's data.
 */
@Component({
  selector: 'app-report-builder-picker',
  templateUrl: './report-builder-picker.component.html',
  styleUrls: ['./report-builder-picker.component.scss'],
  standalone: false
})
export class ReportBuilderPickerComponent implements OnInit {

  schemas: ReportEntitySchema[] = [];
  loadFailed: boolean = false;

  constructor(private reportBuilderService: ReportBuilderService) { }

  ngOnInit(): void {
    this.reportBuilderService.getSchema()
      .pipe(take(1))
      .pipe(catchError((e) => { this.loadFailed = true; return e; }))
      .subscribe((schemas: ReportEntitySchema[]) => { this.schemas = schemas || []; });
  }
}
